import React from 'react';

/**
 * Boxed layout wrapper for page content.
 * Centers content at max 1500px, white background, so Navbar/Footer can
 * keep their full-bleed colored bands while the actual page sits in a card.
 */
const PageBox = ({ children }) => (
  <main className="w-full max-w-[1500px] mx-auto bg-white min-h-[20vh]">
    {children}
  </main>
);

export default PageBox;
